import { Component, OnInit, OnDestroy, ViewChild, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'
import { Columns, Config, DefaultConfig, APIDefinition, API } from 'ngx-easy-table';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { IntranetoldService } from './../../../api/intranetold.service';
import { VentaService } from './../../../api/venta.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import Swal from 'sweetalert2'
import { variableGlobal } from 'src/app/global.enum';
import { VentaLayaultModelComponent } from "../../layout/venta/venta-layault-model";
import { envioCorreoSeguimientoaComponent } from "./envio-correo"
import { environment } from 'src/environments/environment';
import { SeguimientoOportunidadComponent } from './seguimiento-oportunidad/seguimiento-oportunidad.component';
import { SapService } from 'src/app/api/sap.service';
import { PagoService, PagoRecibidoPayload, ChequeDTO, TransferenciaDTO, EfectivoDTO, TarjetaCreditoDTO } from 'src/app/api/pago.service';


@Component({
  selector: 'app-seguimiento',
  templateUrl: './seguimiento.component.html',
  styleUrls: ['./seguimiento.component.css','./seguimiento.component.sass']
})
export class SeguimientoComponent implements OnInit, OnDestroy {

  constructor(
    private _activeRoute: ActivatedRoute,
    private _api: IntranetoldService,
    private _apiVenta: VentaService,
    private modalService: NgbModal,
    private _dbService: NgxIndexedDBService,
    private _apiSap: SapService,
    private _pagoService: PagoService,

  ) { }
  @ViewChild('table', { static: true }) table: APIDefinition;
  tipoSeguimiento = "";
  titulo = "Seguimiento";
  public configuration: Config;
  public columns: Columns[];
  columnsCopy: Columns[] = [];
  checked = new Set([]);
  data = [];
  vendedores = [];
  cargando:boolean = false;

  // Paginación server-side
  currentPage: number = 1;
  pageSize: number = 25;
  totalCount: number = 0;
  totalPages: number = 0;

  // Búsqueda con debounce
  searchTerm: string = '';
  private searchSubject = new Subject<string>();
  private searchSubscription: Subscription;

  // Propiedades para el modal de pagos
  documentoSeleccionado: any = null;
  cargandoPagos: boolean = false;
  listaPagos: any[] = [];
  totalPagado: number = 0;
  totalPedido: number = 0;
  totalPendiente: number = 0;
  creandoPago: boolean = false; // controla si se muestran formularios de creación
  // Para transferencia bancaria: viene de query "traeBancos"
  // Usamos CuentaContable (valor), y mostramos NombreCuentaContable en el select (conservamos NombreBanco como referencia)
  cuentasBanco: Array<{ CuentaContable: string; NombreBanco?: string; NombreCuentaContable: string }>=[];
  cuentasEfectivo: Array<{ AcctCode: string; AcctName: string }>=[]; // Para fondo en efectivo
  // Bancos para cheques (ODSC)
  bancosCheques: Array<{ BankCode: string; BankName: string }>=[];
  // Catálogo OACT para mapear _SYS (AcctCode) a FatherNum (solo visual)
  cuentasOACT: Array<{ AcctCode: string; FatherNum: string; AcctName?: string }>=[];
  // Soporte UI: referencia para modal de cuentas (flecha amarilla)
  @ViewChild('modalCuentaMayor', { static: false }) modalCuentaMayor: TemplateRef<any>;
  cuentaVistaActual: { acctCode: string; fatherNum: string; acctName: string; origen: 'cheque'|'tarjeta'|'efectivo' } | null = null;

  // Estado y modelos de pago (adaptado del JS legado)
  contador: number = 0;
  jsonIndex: number = 0;
  tarjetaCredito: TarjetaCreditoDTO[] = [];
  nuevaTarjetaCredito: Omit<TarjetaCreditoDTO, 'Number'> = {
    creditCard: 0,
    account: '',
    creditCardNumber: '',
    validUntil: '',
    ownerIDNumber: '',
    ownerPhone: '',
    paymentMethod: '',
    ammountDue: 0,
    numerOfPayment: 1,
    firsAmmountPayment: 0,
    eadAddAmmountPayment: 0,
    voucherNumebr: '',
    transactionType: 'S'
  };
  cheques: ChequeDTO[] = [];
  nuevoCheque: ChequeDTO = { account: '', dueDate: '', ammount: 0, bankTransfer: '', endosado: 'NO', checkNum: '' };
  transferenciaBancaria: TransferenciaDTO = { account: '', date: '', reference: '', ammount: 0, cashFlowLineItemID: 44 };
  efectivo: EfectivoDTO = { account: '', ammount: 0 } as EfectivoDTO;
  posicionesFormulario: Array<{ CFWId: number; CFWName: string }> = [];

  @ViewChild('frmNumeroDocumento', { static: true }) frmNumeroDocumento: TemplateRef<any>;
  @ViewChild('frmEstado', { static: true }) frmEstado: TemplateRef<any>;
  @ViewChild('frmU_IND_EstadosNV', { static: true }) frmU_IND_EstadosNV: TemplateRef<any>;
  @ViewChild('frmVendedor', { static: true }) frmVendedor: TemplateRef<any>;
  @ViewChild('frmFechaDocumento', { static: true }) frmFechaDocumento: TemplateRef<any>;
  @ViewChild('frmFechaEntrega', { static: true }) frmFechaEntrega: TemplateRef<any>;
  @ViewChild('frmDocTotal', { static: true }) frmDocTotal: TemplateRef<any>;
  @ViewChild('frmAccion', { static: true }) frmAccion: TemplateRef<any>;
  @ViewChild('frmPago', { static: true }) frmPago: TemplateRef<any>;
  @ViewChild('frmDTE', { static: true }) frmDTE: TemplateRef<any>;
  @ViewChild('modalPagos', { static: false }) modalPagos: TemplateRef<any>;
  @ViewChild('modalDTE', { static: false }) modalDTE: TemplateRef<any>;
  @ViewChild('frmFolioClickable', { static: true }) frmFolioClickable: TemplateRef<any>;

  dteViewer = { url: '', folio: '', loading: false, error: '' };
  private dteObjectUrl: string | null = null;

  async ngOnInit() {
    this.obtieneTitulo();
    this.configurarColumnas();

    // Cargar vendedores en paralelo
    var objeto = "SELECT * FROM [OSLP]";
    var dato: any = await this._api.GetNotFileQuery(objeto);
    this.vendedores = dato.objeto;

    // Configurar tabla: desactivar paginación/búsqueda interna de ngx-easy-table
    this.configuration = {
      ...DefaultConfig,
      searchEnabled: false,
      detailsTemplate: true,
      paginationRangeEnabled: false,
      paginationEnabled: false,
      horizontalScroll: true,
      resizeColumn: false,
      orderEnabled: true,
      rowReorder: false,
      columnReorder: false,
      fixedColumnWidth: true,
    };

    // Suscripción de búsqueda con debounce
    this.searchSubscription = this.searchSubject.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(async (term) => {
      this.searchTerm = term;
      this.currentPage = 1;
      await this.cargarPagina();
    });

    // Obtener login para filtro de perfil
    this._dbService.getByID(variableGlobal.DB_TABLE_GENERAL, variableGlobal.DB_TABLE_GENERAL_id_login).subscribe(
      async item => {
        var itemx: any = item;
        this.login = itemx.datos.login;
      }
    );

    if (variableGlobal.ESTILO_EASY_TABLE) {
      this.setClass(variableGlobal.ESTILO_EASY_TABLE);
    }

    // Cargar primera página
    await this.cargarPagina();
  }

  ngOnDestroy() {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
  }

  // Helpers para la UI de tarjeta: fecha de hoy en formato input date (yyyy-MM-dd)
  private todayIso(): string {
    const d = new Date();
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  // Al cambiar forma de pago (débito/crédito) autocompleta y bloquea campos según diseño original
  onPaymentMethodChange() {
    const method = this.nuevaTarjetaCredito.paymentMethod;
    const accountByMethod: Record<string, string> = {
      '1': '_SYS00000002266',
      '2': '_SYS00000002267',
    };
    this.nuevaTarjetaCredito.account = accountByMethod[method] || '';
    this.nuevaTarjetaCredito.validUntil = this.todayIso();
    if (!this.nuevaTarjetaCredito.transactionType) this.nuevaTarjetaCredito.transactionType = 'S';
  }

  nombrePrincipal = "";
  ObjTypeDoc = "";
  obtieneTitulo() {
    this.tipoSeguimiento = this._activeRoute.snapshot.paramMap.get("tipoSeguimiento");
    const config = {
      'COT':    { nombre: 'Cotización',     titulo: 'Seguimiento de cotización',        objType: '23' },
      'NV':     { nombre: 'Nota de venta',  titulo: 'Seguimiento nota de venta',        objType: '17' },
      'OFECOM': { nombre: 'Oferta de compra', titulo: 'Seguimiento oferta de compra',   objType: '540000006' },
      'COMPRA': { nombre: 'Pedido en transito', titulo: 'Seguimiento pedido en transito', objType: '22' },
      'FAC':    { nombre: 'Seguimiento factura', titulo: 'Seguimiento factura',          objType: '13' },
      'BOL':    { nombre: 'Seguimiento boleta', titulo: 'Seguimiento boleta',            objType: '13' },
      'SD':     { nombre: 'Seguimiento Solicitud de Devolución', titulo: 'Seguimiento Solicitud de Devolución', objType: '234000031' },
    };
    const c = config[this.tipoSeguimiento];
    if (c) {
      this.nombrePrincipal = c.nombre;
      this.titulo = c.titulo;
      this.ObjTypeDoc = c.objType;
    }
  }

  /** Configura las columnas de la tabla según el tipoSeguimiento */
  private configurarColumnas() {
    switch (this.tipoSeguimiento) {
      case 'COT':
        this.columns = [
          { key: 'DocEntry', title: 'Acción', width: '100px', cellTemplate: this.frmAccion },
          { key: 'DocNum', title: 'N°', width: '100px' },
          { key: 'DocStatus', title: 'Estado', width: '100px', cellTemplate: this.frmEstado },
          { key: 'DocCur', title: 'Moneda', width: '100px' },
          { key: 'CardName', title: 'Cliente', width: '300px' },
          { key: 'VendedorNombre', title: 'Vendedor', width: '300px', cellTemplate: this.frmVendedor },
          { key: 'DocDate', title: 'Fecha documento', cellTemplate: this.frmFechaDocumento },
          { key: 'DocTotal', title: 'Total Neto', cellTemplate: this.frmDocTotal },
        ];
        break;
      case 'NV':
        this.columns = [
          { key: '', title: 'Acción', width: '100px', cellTemplate: this.frmAccion, searchEnabled: false, orderEnabled: false },
          { key: 'DocNum', title: 'N°', width: '100px' },
          { key: 'FolioNum_FAC', title: 'Folio FAC', width: '100px' },
          { key: 'DocStatus', title: 'Estado', width: '100px', cellTemplate: this.frmEstado },
          { key: 'U_IND_EstadosNV', title: 'Estado', width: '100px', cellTemplate: this.frmU_IND_EstadosNV },
          { key: 'DocCur', title: 'Moneda', width: '100px' },
          { key: 'CardName', title: 'Cliente', width: '300px' },
          { key: 'VendedorNombre', title: 'Vendedor', width: '300px', cellTemplate: this.frmVendedor },
          { key: 'NumAtCard', title: 'OC Cliente', width: '300px' },
          { key: 'DocDate', title: 'Fecha emisión', cellTemplate: this.frmFechaDocumento },
          { key: 'DocTotal', title: 'Total Neto', cellTemplate: this.frmDocTotal },
          { key: 'FolioNum_GD', title: 'GD', width: '100px' },
          { key: 'DocNum_FAC', title: 'FAC NV', width: '100px' },
        ];
        break;
      case 'FAC':
        this.columns = [
          { key: 'Pago', title: 'Pago', width: '100px', cellTemplate: this.frmPago, searchEnabled: false, orderEnabled: false },
          { key: 'DocNum', title: 'N°', width: '100px' },
          { key: 'FolioNum', title: 'Folio', width: '100px', cellTemplate: this.frmFolioClickable },
          { key: 'DocStatus', title: 'Estado', width: '100px', cellTemplate: this.frmEstado },
          { key: 'DocCur', title: 'Moneda', width: '100px' },
          { key: 'CardName', title: 'Cliente', width: '300px' },
          { key: 'VendedorNombre', title: 'Vendedor', width: '300px', cellTemplate: this.frmVendedor },
          { key: 'NumAtCard', title: 'OC Cliente', width: '300px' },
          { key: 'DocDate', title: 'Fecha emisión', cellTemplate: this.frmFechaDocumento },
          { key: 'DocTotalFC', title: 'Total Neto', cellTemplate: this.frmDocTotal },
        ];
        break;
      case 'BOL':
        this.columns = [
          { key: 'Pago', title: 'Pago', width: '100px', cellTemplate: this.frmPago, searchEnabled: false, orderEnabled: false },
          { key: 'DocNum', title: 'N°', width: '100px' },
          { key: 'FolioNum', title: 'Folio', width: '120px', cellTemplate: this.frmFolioClickable },
          { key: 'DocStatus', title: 'Estado', width: '100px', cellTemplate: this.frmEstado },
          { key: 'DocCur', title: 'Moneda', width: '100px' },
          { key: 'CardName', title: 'Cliente', width: '300px' },
          { key: 'VendedorNombre', title: 'Vendedor', width: '300px', cellTemplate: this.frmVendedor },
          { key: 'DocDate', title: 'Fecha emisión', cellTemplate: this.frmFechaDocumento },
          { key: 'DocTotalFC', title: 'Total', cellTemplate: this.frmDocTotal },
        ];
        break;
      case 'OFECOM':
        this.columns = [
          { key: 'DocEntry', title: 'Acción', width: '100px', cellTemplate: this.frmAccion },
          { key: 'DocNum', title: 'N°', width: '100px' },
          { key: 'DocStatus', title: 'Estado', width: '100px', cellTemplate: this.frmEstado },
          { key: 'DocCur', title: 'Moneda', width: '100px' },
          { key: 'CardName', title: 'Cliente', width: '300px' },
          { key: 'VendedorNombre', title: 'Vendedor', width: '300px', cellTemplate: this.frmVendedor },
          { key: 'DocDate', title: 'Fecha documento', cellTemplate: this.frmFechaDocumento },
          { key: 'DocTotal', title: 'Total Neto', cellTemplate: this.frmDocTotal },
        ];
        break;
      case 'COMPRA':
      case 'SD':
        this.columns = [
          { key: '', title: 'Acción', width: '100px', cellTemplate: this.frmAccion, searchEnabled: false, orderEnabled: false },
          { key: 'DocNum', title: 'N°', width: '100px' },
          { key: 'DocStatus', title: 'Estado', width: '100px', cellTemplate: this.frmEstado },
          { key: 'DocCur', title: 'Moneda', width: '100px' },
          { key: 'CardName', title: 'Cliente', width: '300px' },
          { key: 'VendedorNombre', title: 'Vendedor', width: '300px', cellTemplate: this.frmVendedor },
          { key: 'NumAtCard', title: 'OC Cliente', width: '300px' },
          { key: 'DocDate', title: 'Fecha emisión', cellTemplate: this.frmFechaDocumento },
          { key: 'DocTotal', title: 'Total Neto', cellTemplate: this.frmDocTotal },
          { key: 'FolioNum_GD', title: 'GD', width: '100px' },
          { key: 'DocNum_FAC', title: 'FAC', width: '100px' },
        ];
        break;
    }
  }

  login:any;
  usuarios:any;
  usuarioON:any;
  dataView:any;
  perfilUsuario:any;

  /** Carga una página de datos del backend con paginación real */
  async cargarPagina() {
    this.cargando = true;
    try {
      const res: any = await this._api.getSeguimientoPaginado(
        this.tipoSeguimiento,
        this.currentPage,
        this.pageSize,
        this.searchTerm
      );


      if (res.estado) {
        this.data = res.objeto.data || [];
        this.totalCount = res.objeto.totalCount || 0;
        this.totalPages = Math.ceil(this.totalCount / this.pageSize);

        // Post-procesamiento: calcular DocTotal neto y nombre del vendedor
        this.data.forEach(element => {
          if (element.DocTotal !== undefined && element.VatSum !== undefined) {
            element.DocTotal = element.DocTotal - element.VatSum;
          }
          element.VendedorNombre = this.vendedorCodigoATexto(element.SlpCode);
        });

        // Filtro por perfil para NV/COT (vendedor específico)
        if ((this.tipoSeguimiento == 'NV' || this.tipoSeguimiento == 'COT') && this.login) {
          if (this.login.PERFIL == '6117f718d80c1010920b8537') {
            this.data = this.data.filter(objeto => {
              return objeto.SlpCode === parseInt(this.login.VENDEDOR) || objeto.U_IND_INTRANET_CREADOR == this.login.VENDEDOR;
            });
          }
        }
      } else {
        
        this.data = [];
        this.totalCount = 0;
        this.totalPages = 0;
      }
    } catch (err) {
      
      this.data = [];
      this.totalCount = 0;
      this.totalPages = 0;
    }
    this.cargando = false;
  }

  // Búsqueda: disparada desde el input con debounce
  onSearchChange(term: string) {
    this.searchSubject.next(term);
  }

  // Navegación de páginas
  async irAPagina(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    await this.cargarPagina();
  }

  async paginaAnterior() {
    await this.irAPagina(this.currentPage - 1);
  }

  async paginaSiguiente() {
    await this.irAPagina(this.currentPage + 1);
  }

  /** Genera el array de números de página para la UI */
  get paginasVisibles(): number[] {
    const pages: number[] = [];
    const maxVisible = 5;
    let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
    let end = Math.min(this.totalPages, start + maxVisible - 1);
    if (end - start < maxVisible - 1) {
      start = Math.max(1, end - maxVisible + 1);
    }
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  }

  private setClass(name: string): void {
    this.table.apiEvent({
      type: API.setTableClass,
      value: name,
    });
  }



  vendedorCodigoATexto(slpCode) {
    var SlpName = "";
    this.vendedores.forEach(function (a) {
      if (a) {
        if (a.SlpCode == slpCode) {
          SlpName = a.SlpName;
        }
      }

    })
    return SlpName;
  }


  public clicked: string;
  eventEmitted($event: { event: string; value: any }): void {
    //this.clicked = JSON.stringify($event);



    if ($event.event == "onRowDrop") {
      //this.moverIdiceTabla($event.value.currentIndex, $event.value.previousIndex);

    }
  }


  async EnviaCoreo(data) {
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "xl",
      //modalDialogClass:variableGlobal.CLASS_MODAL_BG,
      scrollable: true
    };
    
    const modalRef = this.modalService.open(envioCorreoSeguimientoaComponent, ngbModalOptions);
    modalRef.componentInstance.data = data;
    modalRef.componentInstance.origen = this.tipoSeguimiento;
    modalRef.componentInstance.modalReference = modalRef;
    modalRef.result.then((data) => {


    }, (reason) => {
      //this.editar(item);
    });
  }
  validateEmail(email) {

    //const re = /^(([^<>()[\]\\.,;:\s@@"]+(\.[^<>()[\]\\.,;:\s@@"]+)*)|(".+"))@@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //return re.test(String(email).toLowerCase());
    try {
      let pattern = new RegExp("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$");
      let valid = pattern.test(email);
      return valid;
    } catch (TypeError) {
      return false;
    }
  }


  async CerrarDoc(row) {
    var ObjType = "17";
    var cerrada = "cerrada";
    if (this.tipoSeguimiento == "COT") {
      ObjType = "23";
    }
    else if (this.tipoSeguimiento == "OFECOM") {
      ObjType = "540000006";
      cerrada = "cerrado";
    }
    else if (this.tipoSeguimiento == "COMPRA") {
      ObjType = "22";
      cerrada = "cerrado";
    }
    else if (this.tipoSeguimiento == "SD") {
      ObjType = "234000031";
      cerrada = "cerrado";
    }

    var DocEntry = row.DocEntry;
    var DocNum = row.DocNum;

    Swal.fire({
      title: "¿Cerrar " + this.nombrePrincipal + " " + DocNum + " ?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Si",
      denyButtonText: "No",

    }).then(async (result) => {

      if (result.isConfirmed) {


        Swal.fire({
          title: 'Espere por favor!',
          html: 'Se está cerrado el documento',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading()
          },
        });


        var datos: any = await this._apiVenta.CerrarDocumento(DocEntry, ObjType);
        
        if (datos.estado) {
          row.DocStatus = "C";
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: this.nombrePrincipal + " " + cerrada,
            showConfirmButton: false,
            timer: 6000
          })

        }
        else {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: datos.mensaje,
            showConfirmButton: false,
            timer: 6000
          })
        }


      }
      else if (result.isDenied) {
        //Swal.fire('Documento no alterado, puede continuar', '', 'info')
      }
    })

  }

  async generarNV(row) {
    Swal.fire({
      title: "¿Estas seguro que quieres crear la Nota de venta de la Cotización " + row.DocNum + " ?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Si",
      denyButtonText: "No",

    }).then(async (result) => {

      if (result.isConfirmed) {


        Swal.fire({
          title: 'Espere por favor!',
          html: 'Se está creando el documento',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading()
          },
        });

        var datos: any = await this._apiVenta.CotizacionANV(row.DocEntry);

        var numerosExtraidos:any;
        if (datos.estado) {

          

          const numerosEncontrados = datos.mensaje.match(/\d+/g);

          if (numerosEncontrados) {
            numerosExtraidos = numerosEncontrados.map(Number);
            
          } else {
            
          }

          var data: any = await this._api.getQueryAll();
          var objeto:any;
          var dato:any;

          await data.objeto.forEach(element => {
            if (element.NOMBRE == "seguimientoNotaVenta") {
              objeto = element.CONSULTA;
            }
          });
          dato = await this._api.GetNotFileQuery(objeto);
          var notasDeVenta = dato.objeto;

          

          notasDeVenta = notasDeVenta.filter( x => x.DocNum == numerosExtraidos );

          


          
          this.documentoOportunidad.OPR1[this.documentoOportunidad.OPR1.length - 1].DocId = notasDeVenta[0].DocEntry;
          this.documentoOportunidad.OPR1[this.documentoOportunidad.OPR1.length - 1].ObjType = "17";
          

          let res:any = await this._apiSap.creaActualizaOportunidad(this.documentoOportunidad);
          

          row.DocStatus = "C";
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: datos.mensaje,
            showConfirmButton: false,
            timer: 6000
          })

        }
        else {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: datos.mensaje,
            showConfirmButton: false,
            timer: 6000
          })
        }


      }
      else if (result.isDenied) {
        Swal.fire('Documento no alterado, puede continuar', '', 'info')
      }
    })
  }

  async generarOC(row) {
    Swal.fire({
      title: "¿Estas seguro que quieres crear Pedido en transito de la Oferta de compra " + row.DocNum + " ?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Si",
      denyButtonText: "No",

    }).then(async (result) => {

      if (result.isConfirmed) {

        Swal.fire({
          title: 'Espere por favor!',
          html: 'Se está creando el documento',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading()
          },
        });

        var datos: any = await this._apiVenta.OfertaAOC(row.DocEntry);
        
        if (datos.estado) {
          row.DocStatus = "C";
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: datos.mensaje,
            showConfirmButton: false,
            timer: 6000
          })

        }
        else
        {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: datos.mensaje,
            showConfirmButton: false,
            timer: 6000
          })
        }

      }
      else if (result.isDenied) {
        Swal.fire('Documento no alterado, puede continuar', '', 'info')
      }
    })
  }

  abrirLayout(item) {
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "xl",
      scrollable: true
    };

    var urlIframe = environment.RUTA_API + "/WEB/viewLayault?ObjType=" + this.ObjTypeDoc + "&DocEntry=" + item.DocEntry;
    var urlImprimir = environment.RUTA_API + "/WEB/viewLayoultPDF?ObjType=" + this.ObjTypeDoc + "&DocEntry=" + item.DocEntry;
    
    const modalRef = this.modalService.open(VentaLayaultModelComponent, ngbModalOptions);
    modalRef.componentInstance.ObjType = this.ObjTypeDoc;
    modalRef.componentInstance.DocEntry = item.DocEntry;
    modalRef.componentInstance.urllayout = urlIframe;
    modalRef.componentInstance.urlImprimir = urlImprimir;


    modalRef.componentInstance.DocNum = item.DocNum;
    modalRef.componentInstance.modalReference = modalRef;
    modalRef.result.then((data) => {


    }, (reason) => {
      //this.editar(item);
    });
  }

  // Construye URL al DTE PDF según tipo de documento (FAC/BOL) y FolioNum
  getDTEUrl(row: any): string | null {
    const folio = row?.FolioNum;
    if (!folio) return null;
    let prefijo = '';
    if (this.tipoSeguimiento === 'FAC') {
      prefijo = '33';
    } else if (this.tipoSeguimiento === 'BOL') {
      prefijo = '39';
    } else {
      return null;
    }
    return `https://terraapi.indeone.app/api/PDF/getDTE?prefijo=${prefijo}&folio=${encodeURIComponent(folio)}`;
  }

  abrirDteModal(row: any) {
    const url = this.getDTEUrl(row);
    if (!url) return;
    this.dteViewer = { url: '', folio: String(row.FolioNum), loading: true, error: '' };
    const modalRef = this.modalService.open(this.modalDTE, { backdrop: 'static', keyboard: true, size: 'lg', modalDialogClass: 'modal-dialog-centered' });
    // Descarga como blob para evitar restricciones de embed (X-Frame-Options) si el endpoint lo permite
      const candidateBases: string[] = [
        url,
      ];
      const tryFetchModes = async (u: string): Promise<boolean> => {
        const modes: RequestCredentials[] = ['omit', 'include'];
        for (const mode of modes) {
          
          try {
            const r = await fetch(u, { credentials: mode });
            if (!r.ok) throw new Error('HTTP ' + r.status + ' ' + r.statusText);
            const ct = (r.headers.get('Content-Type') || '').toLowerCase();
            const blob = await r.blob();
            if (!blob || blob.size === 0) throw new Error('Blob vacío');
            if (this.dteObjectUrl) URL.revokeObjectURL(this.dteObjectUrl);
            this.dteObjectUrl = URL.createObjectURL(blob);
            this.dteViewer.url = this.dteObjectUrl;
            return true;
          } catch (e) {
            
          }
        }
        return false;
      };

      (async () => {
        let loaded = await tryFetchModes(url);
        if (!loaded) {
          
          this.dteViewer.url = url; // confiamos en el SafeUrl pipe
        }
        this.dteViewer.loading = false;
      })();
    modalRef.result.finally(()=>{ 
      if (this.dteObjectUrl) { URL.revokeObjectURL(this.dteObjectUrl); this.dteObjectUrl = null; }
      this.dteViewer = { url: '', folio: '', loading: false, error: '' }; 
    });
  }

  // ===== UI Flecha amarilla (visual) para Cuenta de mayor/Caja =====
  abrirCuentaMayor(origen: 'cheque'|'tarjeta'|'efectivo') {
    // Determinar cuenta _SYS según origen; sólo visualiza, no permite editar
    let acctCode = '';
    if (origen === 'cheque') acctCode = this.nuevoCheque?.account || '';
    if (origen === 'tarjeta') acctCode = this.nuevaTarjetaCredito?.account || '';
    if (origen === 'efectivo') acctCode = this.efectivo?.account || '';
    const row = this.cuentasOACT?.find(x => String(x.AcctCode).trim() === String(acctCode).trim());
    this.cuentaVistaActual = {
      acctCode: acctCode || '',
      fatherNum: row?.FatherNum || (acctCode || ''),
      acctName: row?.AcctName || '',
      origen
    };
    this.modalService.open(this.modalCuentaMayor, { backdrop: 'static', keyboard: true, size: 'md' });
  }

  async abrirModalPagos(row: any) {
    
    this.documentoSeleccionado = row;
    this.creandoPago = false;
    this.cargandoPagos = true;
    this.listaPagos = [];
    this.totalPagado = 0;
    this.totalPedido = Number(row?.DocTotalFC) || 0;
    this.totalPendiente = this.totalPedido;

    // Inicializar modelos para binding
    this.transferenciaBancaria = { account: '_SYS00000002308', date: '', reference: '', ammount: 0, cashFlowLineItemID: 44 };
    this.efectivo = { account: '_SYS00000001298', ammount: 0 } as EfectivoDTO;
    this.nuevoCheque = { account: '_SYS00000001322', dueDate: '', ammount: 0, bankTransfer: '', endosado: 'NO', checkNum: '' };
    this.nuevaTarjetaCredito = {
      creditCard: 0, account: '', creditCardNumber: '', validUntil: '', ownerIDNumber: '', ownerPhone: '',
      paymentMethod: '', ammountDue: 0, numerOfPayment: 1, firsAmmountPayment: 0, eadAddAmmountPayment: 0, voucherNumebr: '', transactionType: 'S'
    };

    // Abrir modal inmediatamente (con spinner de carga)
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "lg",
      scrollable: true
    };
    const modalRef = this.modalService.open(this.modalPagos, ngbModalOptions);
    modalRef.result.then((result) => {
    }, (reason) => {
    });

    // Cargar datos en paralelo en segundo plano
    try {
      const [pagosResult, bancosResult] = await Promise.all([
        this.cargarPagosDelDocumento(row),
        this.cargarDatosBancarios()
      ]);
    } catch (err) {
      
    } finally {
      this.cargandoPagos = false;
    }
  }

  /** Carga cuentas bancarias, bancos de cheques y catálogo OACT en paralelo */
  private async cargarDatosBancarios() {
    try {
      const dataQueries: any = await this._api.getQueryAll();
      let sqlTraeBancos = '';
      dataQueries.objeto.forEach(element => {
        if (element.NOMBRE === 'traeBancos') {
          sqlTraeBancos = element.CONSULTA;
        }
      });

      // Ejecutar las 3 queries en paralelo
      const [resBancos, resBancosCheques, resOact] = await Promise.all([
        sqlTraeBancos ? this._api.GetNotFileQuery(sqlTraeBancos) : Promise.resolve({ objeto: [] }),
        this._api.GetNotFileQuery('SELECT "BankCode", "BankName" FROM ODSC ORDER BY "BankName"'),
        this._api.GetNotFileQuery('SELECT "AcctCode", "FatherNum", "AcctName" FROM OACT')
      ]);

      // Procesar cuentas de banco
      const rowsBancos: any[] = Array.isArray((resBancos as any)?.objeto) ? (resBancos as any).objeto : [];
      this.cuentasBanco = rowsBancos.map(r => ({
        CuentaContable: r['CuentaContable'] || r['GLAccount'] || r['AcctCode'] || '',
        NombreBanco: r['NombreBanco'] || r['BankName'] || '',
        NombreCuentaContable: r['NombreCuentaContable'] || r['AcctName'] || ''
      })).filter(x => x.CuentaContable);

      // Procesar bancos para cheques
      this.bancosCheques = Array.isArray((resBancosCheques as any)?.objeto) ? (resBancosCheques as any).objeto : [];

      // Procesar OACT
      this.cuentasOACT = Array.isArray((resOact as any)?.objeto) ? (resOact as any).objeto : [];

      // Cargar posiciones formulario principal (OCFW)
      let sqlPosicion = '';
      dataQueries.objeto.forEach(element => {
        if (element.NOMBRE === 'posicionFormularioPrincipal') {
          sqlPosicion = element.CONSULTA;
        }
      });
      if (sqlPosicion) {
        const resCfw: any = await this._api.GetNotFileQuery(sqlPosicion);
        this.posicionesFormulario = Array.isArray(resCfw?.objeto) ? resCfw.objeto : [];
      }
    } catch (err) {
      
      this.cuentasBanco = [];
      this.bancosCheques = [];
      this.cuentasOACT = [];
      this.posicionesFormulario = [];
    }
  }

  async cargarPagosDelDocumento(documento: any) {
    // Limpiar y setear total base del documento
    this.listaPagos = [];
  // Usar estrictamente DocTotalFC como total del documento
  this.totalPedido = Number(documento?.DocTotalFC) || 0;
    this.totalPagado = 0;
    this.totalPendiente = this.totalPedido;

    try {
      const docEntry = Number(documento?.DocEntry);
      if (!docEntry || Number.isNaN(docEntry)) {
        
        return;
      }
      // Obtener SQL por nombre y reemplazar placeholder
      const data: any = await this._api.getQueryAll();
      let sql = '';
      await data.objeto.forEach(element => {
        if (element.NOMBRE === 'traePagosFactura') {
          sql = element.CONSULTA;
        }
      });
      if (!sql) {
        
        return;
      }
      const consulta = sql.replace(/REEMPLAZAFACTURA/g, String(docEntry));
      const res: any = await this._api.GetNotFileQuery(consulta);
      const rows: any[] = res?.objeto || [];
      // Mapear filas a la estructura de UI
      this.listaPagos = rows.map((r, i) => {
        const total = Number(r['Total'] || 0);
        return {
          numero: r['N° Pago'] ?? r['DocNum'] ?? `P-${i + 1}`,
          fecha: r['Fecha'] ?? r['DocDate'],
          tipo: r['Tipo'] ?? 'Pago recibido',
          referencia: r['Referencia'] ?? '',
          total: total,
          estado: r['Estado'] ?? 'Pagado',
          raw: r,
        };
      });
      this.totalPagado = this.listaPagos.reduce((acc, p) => acc + (Number(p.total) || 0), 0);
      this.totalPendiente = Math.max(0, (Number(this.totalPedido) || 0) - this.totalPagado);
    } catch (e) {
      
    }
  }

  iniciarCreacionPago() {
    this.creandoPago = true;
  }

  cancelarCreacionPago() {
    this.creandoPago = false;
    // Opcional: reset de modelos si se desea limpiar al cancelar
    this.transferenciaBancaria = { account: '', date: '', reference: '', ammount: 0, cashFlowLineItemID: 44 };
    this.efectivo = { account: '', ammount: 0 } as EfectivoDTO;
    this.nuevoCheque = { account: '', dueDate: '', ammount: 0, bankTransfer: '', endosado: 'NO', checkNum: '' };
    this.nuevaTarjetaCredito = {
      creditCard: 0, account: '', creditCardNumber: '', validUntil: '', ownerIDNumber: '', ownerPhone: '',
      paymentMethod: '', ammountDue: 0, numerOfPayment: 1, firsAmmountPayment: 0, eadAddAmmountPayment: 0, voucherNumebr: '', transactionType: 'S'
    };
    this.cheques = [];
    this.tarjetaCredito = [];
  }

  documentoOportunidad:any;

  agregarOportunidad(row:any){


    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "xl",
      scrollable: true
    };

    const modalRef = this.modalService.open(SeguimientoOportunidadComponent, ngbModalOptions);
    modalRef.componentInstance.documento = row;
    modalRef.componentInstance.desdeVenta = true;
    modalRef.componentInstance.modalReference = modalRef;

    modalRef.result.then((data) => {

    if (data) {
      this.documentoOportunidad = data;
      this.generarNV(row);
    }
    else
    {
      Swal.fire("Mensaje", "El documento debe tener una oportunidad enlazada para ser creado", "error");
    }

    });

  }

  // ============================
  // Pagos: lógica principal TS
  // ============================

  private formatDateDDMMYYYY(d: Date | string): string {
    try {
      const date = typeof d === 'string' ? new Date(d) : d;
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const yyyy = date.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    } catch {
      return '';
    }
  }

  private hoyDDMMYYYY(): string {
    return this.formatDateDDMMYYYY(new Date());
  }

  private crearDocumentoPago(): PagoRecibidoPayload {
    const doc = this.documentoSeleccionado || {};
    const hasTransfer = this.transferenciaBancaria && (
      (this.transferenciaBancaria.account && this.transferenciaBancaria.account.trim() !== '') ||
      (this.transferenciaBancaria.date && this.transferenciaBancaria.date.trim() !== '') ||
      (this.transferenciaBancaria.reference && this.transferenciaBancaria.reference.trim() !== '') ||
      (Number(this.transferenciaBancaria.ammount) > 0)
    );
    const transferencia = hasTransfer ? this.transferenciaBancaria : null;

    const hasCash = this.efectivo && (
      (this.efectivo.account && this.efectivo.account.trim() !== '') ||
      (Number(this.efectivo.ammount) > 0)
    );
    const efectivo = hasCash ? this.efectivo : null;
    const payload: PagoRecibidoPayload = {
      cardCode: doc.CardCode || '',
      fecha: this.hoyDDMMYYYY(), // mantener formato dd/MM/yyyy como en backend .NET
      comments: 'CARGA INDESAD',
      docEntryReference: doc.DocEntry,
      objTypeReference: this.ObjTypeDoc,
      commentsReference: '',
      cheque: this.cheques || [],
      transferenciaBancaria: transferencia,
      tarjetaCredito: this.tarjetaCredito || [],
      efectivo: efectivo,
    };
    return payload;
  }

  // Habilita envío si hay tarjeta en edición con monto y método, aunque no se haya presionado "Nuevo"
  get hasTarjetaPendiente(): boolean {
    try {
      const m = this.nuevaTarjetaCredito?.paymentMethod;
      const amt = Number(this.nuevaTarjetaCredito?.ammountDue) || 0;
      return !!(m && amt > 0);
    } catch { return false; }
  }

  async enviarPagos() {
    // Construir payload para /api/SAP/creaPagoRecibido
    const doc = this.documentoSeleccionado || {};
    const confirm = await Swal.fire({
      title: 'Confirmar',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Si',
      denyButtonText: 'No',
    });
    if (!confirm.isConfirmed) {
      Swal.fire('Documento no enviado a SAP, puede continuar', '', 'info');
      return;
    }

    try {
      // Si no se agregó con "Nuevo" pero hay tarjeta en edición válida, incluirla implícitamente
      const tarjetasFuente = (this.tarjetaCredito && this.tarjetaCredito.length)
        ? this.tarjetaCredito
        : (this.hasTarjetaPendiente ? [{ Number: 1, splitCreditVoucher: false, transactionType: this.nuevaTarjetaCredito.transactionType || 'S', ...this.nuevaTarjetaCredito }] as TarjetaCreditoDTO[] : []);

      // Mapear estructuras según guía (solo tarjetas con monto > 0)
      const tarjetas = (tarjetasFuente || [])
        .filter(t => Number(t.ammountDue) > 0)
        .map(t => ({
        CreditCard: t.creditCard,
        Account: t.account,
        CreditCardNumber: t.creditCardNumber,
        ValidUntil: t.validUntil ? new Date(t.validUntil).toISOString() : undefined,
        OwnerIDNumber: t.ownerIDNumber,
        OwnerPhone: t.ownerPhone,
        PaymentMethod: t.paymentMethod ? Number(t.paymentMethod) : undefined,
        AmmountDue: Number(t.ammountDue) || 0,
        NumerOfPayment: Number(t.numerOfPayment) || 1,
        FirsAmmountPayment: Number(t.firsAmmountPayment) || 0,
        EadAddAmmountPayment: Number(t.eadAddAmmountPayment) || 0,
        VoucherNumebr: t.voucherNumebr,
        TransactionType: t.transactionType || 'S',
        SplitCreditVoucher: !!t.splitCreditVoucher,
      }));
      // Solo cheques con monto > 0
      const cheques = (this.cheques || [])
        .filter(c => Number(c.ammount) > 0)
        .map(c => ({
        Account: c.account,
        DueDate: c.dueDate ? new Date(c.dueDate).toISOString() : undefined,
        Ammount: Number(c.ammount) || 0,
        BankTransfer: c.bankTransfer || '',
        Endosado: (c.endosado || '').toString().toUpperCase().startsWith('S') ? 'S' : 'N',
        CheckNum: c.checkNum ? Number(c.checkNum) : undefined,
      }));
      // Incluir transferencia solo si tiene cuenta y monto > 0
      const transferencia = (this.transferenciaBancaria && this.transferenciaBancaria.account && Number(this.transferenciaBancaria.ammount) > 0)
        ? {
            Account: this.transferenciaBancaria.account,
            Date: this.transferenciaBancaria.date ? new Date(this.transferenciaBancaria.date).toISOString() : undefined,
            Reference: this.transferenciaBancaria.reference,
            Ammount: Number(this.transferenciaBancaria.ammount) || 0,
            CashFlowLineItemID: this.transferenciaBancaria.cashFlowLineItemID || 44,
          }
        : null;
      // Incluir efectivo solo si tiene cuenta y monto > 0
      const efectivo = (this.efectivo && this.efectivo.account && Number(this.efectivo.ammount) > 0)
        ? {
            Account: this.efectivo.account,
            Ammount: Number(this.efectivo.ammount) || 0,
          }
        : null;
      const resultado = {
        CardCode: doc.CardCode || '',
        Fecha: new Date().toISOString(),
        Comments: 'Pago realizado desde seguimiento',
        DocEntryReference: doc.DocEntry,
        ObjTypeReference: this.ObjTypeDoc,
        CommentsReference: '',
        cheque: cheques.length ? cheques : null,
        transferenciaBancaria: transferencia,
        tarjetaCredito: tarjetas.length ? tarjetas : null,
        efectivo: efectivo,
      };

      const data: any = await this._apiVenta.creaPagoRecibido(resultado);
      
      if (data?.estado) {
        await Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: data.mensaje || 'Pago generado',
          showConfirmButton: false,
          timer: 3000
        });
        // Opcional: refrescar lista de pagos del documento
        this.cargarPagosDelDocumento(this.documentoSeleccionado);
      } else {
        await Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: data?.mensaje || 'No se pudo generar el pago',
          showConfirmButton: false,
          timer: 6000
        });
      }
    } catch (e) {
      await Swal.fire('Error al intentar comunicarse con el servidor', '', 'info');
    }
  }

  // Métodos utilitarios para armar datos desde UI (al enlazar el template)

  agregarCheque(row: ChequeDTO) {
    this.cheques = [...this.cheques, row];
  }

  agregarChequeDesdeUI() {
    // Evitar agregar incompletos: requiere importe y fecha
    const c = this.nuevoCheque;
    if (!c || !c.dueDate || !c.ammount) {
      Swal.fire('Datos incompletos', 'Ingrese al menos fecha y monto del cheque.', 'info');
      return;
    }
    // agregar copia para no mutar la referencia del formulario
    this.agregarCheque({ ...c });
    // resetear formulario de cheque
    this.nuevoCheque = { account: '', dueDate: '', ammount: 0, bankTransfer: '', endosado: 'NO', checkNum: '' };
  }

  eliminarCheque(index: number) {
    this.cheques = this.cheques.filter((_, i) => i !== index);
  }

  agregarTarjetaDesdeUI() {
    const t = this.nuevaTarjetaCredito;
    if (!t) return;
    // Validaciones básicas
    if (!t.account || !t.creditCardNumber || !t.validUntil || !t.ammountDue || !t.creditCard || !t.paymentMethod) {
      Swal.fire('Datos incompletos', 'Complete cuenta, tarjeta (código), número, fecha válida, forma de pago y monto.', 'info');
      return;
    }
    // Registrar tarjeta, asigna Number automáticamente
    this.nuevaTarjeta({ ...t });
    // reset
    this.nuevaTarjetaCredito = {
      creditCard: 0, account: '', creditCardNumber: '', validUntil: '', ownerIDNumber: '', ownerPhone: '',
      paymentMethod: '', ammountDue: 0, numerOfPayment: 1, firsAmmountPayment: 0, eadAddAmmountPayment: 0, voucherNumebr: ''
    };
  }

  eliminarTarjeta(index: number) {
    this.tarjetaCredito = this.tarjetaCredito.filter((_, i) => i !== index);
    // Reasignar Number secuencial por claridad
    this.tarjetaCredito = this.tarjetaCredito.map((t, i) => ({ ...t, Number: i + 1 }));
  }

  onChangeTarjetaCalculos() {
    const total = Number(this.nuevaTarjetaCredito.ammountDue) || 0;
    const cuotas = Math.max(1, Number(this.nuevaTarjetaCredito.numerOfPayment) || 1);
    const { FirstSum, AddPmntSum } = this.calcularCuotas(total, cuotas);
    this.nuevaTarjetaCredito.firsAmmountPayment = FirstSum;
    this.nuevaTarjetaCredito.eadAddAmmountPayment = AddPmntSum;
  }

  setTransferencia(t: TransferenciaDTO | null) {
    this.transferenciaBancaria = t ?? { account: '', date: '', reference: '', ammount: 0, cashFlowLineItemID: 44 };
  }

  setEfectivo(e: EfectivoDTO | null) {
    this.efectivo = e ?? { account: '', ammount: 0 } as EfectivoDTO;
  }

  // ====== Helpers visuales para mostrar FatherNum en lugar de _SYS ======
  private findFatherNum(acctCode: string | null | undefined): string {
    if (!acctCode) return '';
    const row = this.cuentasOACT?.find(x => String(x.AcctCode).trim() === String(acctCode).trim());
    return row?.FatherNum || String(acctCode);
  }
  private findAcctName(acctCode: string | null | undefined): string {
    if (!acctCode) return '';
    const row = this.cuentasOACT?.find(x => String(x.AcctCode).trim() === String(acctCode).trim());
    return row?.AcctName || '';
  }
  get efectivoCuentaLabel(): string {
    return this.findFatherNum(this.efectivo?.account);
  }
  get chequeCuentaLabel(): string {
    return this.findFatherNum(this.nuevoCheque?.account);
  }
  get tarjetaCuentaLabel(): string {
    return this.findFatherNum(this.nuevaTarjetaCredito?.account);
  }
  get efectivoCuentaName(): string {
    return this.findAcctName(this.efectivo?.account);
  }
  get chequeCuentaName(): string {
    return this.findAcctName(this.nuevoCheque?.account);
  }
  get tarjetaCuentaName(): string {
    return this.findAcctName(this.nuevaTarjetaCredito?.account);
  }

  /**
   * Calcula FirstSum y AddPmntSum de acuerdo a cuotas y total (ammountDue)
   */
  calcularCuotas(ammountDue: number, cuotas: number): { FirstSum: number; AddPmntSum: number } {
    let FirstSum = 0;
    let AddPmntSum = 0;
    if (!cuotas || cuotas <= 1) {
      FirstSum = Number(ammountDue) || 0;
      AddPmntSum = 0;
    } else {
      const aux = (Number(ammountDue) || 0) / cuotas;
      if (Math.floor(aux) !== aux) {
        AddPmntSum = Math.floor(aux);
        const parcial = AddPmntSum * (cuotas - 1);
        FirstSum = (Number(ammountDue) || 0) - parcial;
      } else {
        FirstSum = aux;
        AddPmntSum = aux;
      }
    }
    return { FirstSum, AddPmntSum };
  }

  /**
   * Agrega o actualiza una tarjeta de crédito en la posición dada (1-based como en el JS)
   */
  nuevaTarjeta(credito: Omit<TarjetaCreditoDTO, 'Number'>, posicion1Based?: number) {
    const index = posicion1Based ? posicion1Based - 1 : this.tarjetaCredito.length; // almacenar 0-based
    const registro: TarjetaCreditoDTO = { Number: index + 1, splitCreditVoucher: false, transactionType: 'S', ...credito };
    const copia = [...this.tarjetaCredito];
    copia[index] = registro;
    this.tarjetaCredito = copia;
  }

  /**
   * Carga datos de tarjeta desde OCRC
   */
  async cargarOCRC(creditCardCode: string) {
    try {
      //const data = await this._pagoService.getOCRC(creditCardCode);
      const data = {};
      return data; // el componente de UI puede usar esta respuesta para poblar selects/inputs
    } catch (e) {
      return null;
    }
  }

  /**
   * Carga datos de RCT3 para DocEntry existente
   */
  async cargarRCT3(acctCode: string, docNum: number) {
    try {
      const data = {};
      //const data = await this._pagoService.getRCT3(acctCode, docNum);
      return data;
    } catch (e) {
      return null;
    }
  }

}
